import React from 'react';
import { Heading } from '@chakra-ui/react';
import { LayoutAside } from 'features/common/components/Layouts';
import { T } from '@transifex/react';
import { NavigationVertical } from 'features/common/components/Navigation';
import {
  useGetIdManagementMenuItems,
  useGetUserManagementMenuItems,
  useGetorganizationManagementMenuItems,
} from 'features/common/hooks/navigationMenu/useGetNavigationMenuItems';

const AdminSideNav = () => {
  const { userManagementMenuItems } = useGetUserManagementMenuItems();
  const { organizationManagementMenuItems } =
    useGetorganizationManagementMenuItems();
  const { idManagementMenuItems } = useGetIdManagementMenuItems();

  return (
    <LayoutAside order={1}>
      <Heading
        id='admin-user-management-heading'
        variant='section'
        noOfLines={1}
        wordBreak='break-all'
        mb='4'
      >
        <T _str='User management' />
      </Heading>
      {userManagementMenuItems?.length > 0 && (
        <NavigationVertical
          items={userManagementMenuItems}
          aria-labelledby='admin-user-management-heading'
        />
      )}
      {organizationManagementMenuItems?.length > 0 && (
        <>
          <Heading
            id='admin-organization-management-heading'
            variant='section'
            noOfLines={1}
            wordBreak='break-all'
            mb='4'
            mt='6'
          >
            <T _str='Organization management' />
          </Heading>
          <NavigationVertical
            items={organizationManagementMenuItems}
            aria-labelledby='admin-organization-management-heading'
          />
        </>
      )}
      {idManagementMenuItems?.length > 0 && (
        <>
          <Heading
            id='admin-id-management-heading'
            variant='section'
            noOfLines={1}
            wordBreak='break-all'
            mb='4'
            mt='6'
          >
            <T _str='Id management' />
          </Heading>
          <NavigationVertical
            items={idManagementMenuItems}
            aria-labelledby='admin-id-management-heading'
          />
        </>
      )}
    </LayoutAside>
  );
};

export default AdminSideNav;
